import React, { useRef, useState } from 'react';
import { createPortal } from 'react-dom';

// Portaled and fixed: the sidebar clips its own overflow
export function SidebarTooltip({ text, enabled = true, children }) {
  const anchorRef = useRef(null);
  const [position, setPosition] = useState(null);

  const [enabledSeen, setEnabledSeen] = useState(enabled);
  if (enabled !== enabledSeen) {
    setEnabledSeen(enabled);
    setPosition(null);
  }

  const show = () => {
    const rect = anchorRef.current?.getBoundingClientRect();
    if (rect) setPosition({ left: rect.right + 8, top: rect.top + rect.height / 2 });
  };
  const hide = () => setPosition(null);

  return (
    <span
      ref={anchorRef}
      className="vs-anchor"
      onPointerEnter={(event) => { if (event.pointerType === 'mouse') show(); }}
      onPointerLeave={hide}
      onFocus={(event) => { if (event.target.matches(':focus-visible')) show(); }}
      onBlur={hide}
    >
      {children}
      {enabled && position && createPortal(
        <span role="tooltip" className="vs vs-tooltip" style={position}>{text}</span>,
        document.body,
      )}
    </span>
  );
}
